module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_14-8ad2a7b3573d7ba81373a56687d67934.png";